'use strict';

import * as dom from './lib/dom.js';

let lastScrollPosition = 0;
let lastScrollTop = 0;

function getScrollPosition(){
    const headerEl = document.querySelector('.o-main-header');
    const headerGhostEl = document.querySelector('.o-header-ghost-interna');
    const footerEl = document.querySelector('.o-footer');
    let singleEl = document.querySelector('.c-single');
    singleEl = false;
    const singleTextEl = document.querySelector('.c-content-shield');
    const sobreTemplate = document.querySelector('.page-template-page-sobre');
    const searchPage = document.querySelector('body.search-results');
    const windowWidth = window.innerWidth;
    let scrollObject;
    scrollObject = window.pageYOffset;

    if (singleEl) {
        let singleHeight = singleTextEl.offsetHeight;
        let singleTop = singleTextEl.offsetTop;
        const singleProgress = document.querySelector('.js-article-progress');
        if (windowWidth >= 1024) {
            if(scrollObject > singleTop && !dom.hasClass(headerEl, 'is-scrolling--with-ads')){
                let singleProgressWidth = Math.ceil(((100 * (scrollObject - singleTop)) / singleHeight));
                singleProgress.style.width = singleProgressWidth + '%';
            } else {
                singleProgress.style.width = 0 + '%';
            }
        } else {
            if(scrollObject > singleTop){
                let singleProgressWidth = Math.ceil(((100 * (scrollObject - singleTop)) / (singleHeight / 1.85)));
                singleProgress.style.width = singleProgressWidth + '%';
            } else {
                singleProgress.style.width = 0 + '%';
            } 
        }
    }

    if(scrollObject > lastScrollTop){
        dom.addClass(headerEl, 'is-scrolling');
        dom.addClass(headerGhostEl, 'is-scrolling');
    }
    else{
        dom.removeClass(headerEl, 'is-scrolling');
        dom.removeClass(headerGhostEl, 'is-scrolling');
    }

    if(scrollObject < lastScrollPosition){
        dom.addClass(headerEl, 'is-scrolling-up');
    }
    else{
        dom.removeClass(headerEl, 'is-scrolling-up');
    }

    lastScrollPosition = scrollObject;
}

export default function(){
    window.addEventListener('DOMContentLoaded', function() {
        getScrollPosition();
    });

    window.addEventListener('resize', function() {
        getScrollPosition();
    });

    window.addEventListener('scroll', function() {
        getScrollPosition();
    });
}


